import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../common/hooks/hooks";
import { setPluxeeGsm, setPluxeeOtp } from "../../checkoutSlice";
import { selectPluxeeGsm, selectPluxeeOtp } from "../../checkoutSelectors";

const PluxeePaymentForm: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // Read state from Redux
  const gsm = useAppSelector(selectPluxeeGsm);
  const otp = useAppSelector(selectPluxeeOtp);

  // Read the dynamic logo URL defined by the admin in ACF
  const logoUrl = window.commonVariables?.pluxeeLogoUrl;

  // Handle GSM input: Allow only numbers, max length 10
  const handleGsmChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    if (numericValue.length <= 10) {
      dispatch(setPluxeeGsm(numericValue));
    }
  };

  // Handle OTP input: Allow only numbers, max length 6
  const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    if (numericValue.length <= 6) {
      dispatch(setPluxeeOtp(numericValue));
    }
  };

  return (
    <div className="pluxee-payment-form">
      {/* Official Pluxee Logo (Uploaded via ACF) */}
      {logoUrl && (
        <div className="pluxee-payment-form__logo">
          <img
            src={logoUrl}
            alt="Pluxee"
            style={{ maxWidth: "150px", height: "auto", display: "block" }}
          />
        </div>
      )}

      {/* Warning / Instruction Text */}
      <p className="pluxee-payment-form__warning">
        {t(
          "pluxee.warningText",
          'To pay with your Pluxee card, you must generate a mobile payment code by clicking the "Pay" button in the Pluxee Mobile app!',
        )}
      </p>

      {/* GSM Input Field */}
      <div className="form-field pluxee-payment-form__group">
        <label htmlFor="pluxee-gsm">
          {t(
            "pluxee.gsmLabel",
            "Enter the phone number registered in your Pluxee mobile app:",
          )}
        </label>
        <div className="pluxee-payment-form__input-wrapper">
          <span className="pluxee-payment-form__prefix">(+90)</span>
          <input
            id="pluxee-gsm"
            type="tel"
            value={gsm}
            onChange={handleGsmChange}
            placeholder="5XX XXX XX XX"
            maxLength={10}
            className="pluxee-payment-form__input"
          />
        </div>
      </div>

      {/* OTP Input Field */}
      <div className="form-field pluxee-payment-form__group">
        <label htmlFor="pluxee-otp">
          {t(
            "pluxee.otpLabel",
            "Enter the payment code you received from the Pluxee mobile app:",
          )}
        </label>
        <input
          id="pluxee-otp"
          type="text"
          value={otp}
          onChange={handleOtpChange}
          placeholder="123456"
          maxLength={6}
          className="pluxee-payment-form__input"
        />
      </div>
    </div>
  );
};

export default PluxeePaymentForm;
